/**
 * Clean up with `split_share_button_for_tmp_admins experiment` and `split_share_button_for_tmp_admins_gate`
 */

import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import-whitelist
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import type { RouterDataContext } from '@atlassian/react-resource-router';

export const NAV4_TMP_PROJECT_VIEW_ROUTES = new Set([
	'software-archived-work-items',
	'software-backlog',
	'software-boards',
	'software-calendar',
	'software-code',
	'software-deployments',
	'software-form',
	'software-form-builder',
	'software-form-submit',
	'software-goals',
	'software-incidents',
	'software-issue-navigator',
	'software-list',
	'software-release-notes',
	'software-reports',
	'software-requests',
	'software-roadmap',
	'software-security',
	'software-summary',
	'software-timeline',
	'software-versions',
]);

export const NAV3_TMP_PROJECT_VIEW_ROUTES = new Set([
	'software-timeline',
	'software-boards',
	'software-backlog',
]);

/**
 * This function determines if accessLevel should be fetched for project context based on the current route.
 * Our experiment is only targeting the following routes:
 * - TMP project views in Nav4
 * - TMP timeline, board, backlog views in Nav3
 */
export const getIsInProjectAccessRouteWhitelist = (matchedRoute: RouterDataContext) => {
	if (fg('jsw-pndr-add-accesslevel-for-project-context')) {
		return getWillShowNav4()
			? NAV4_TMP_PROJECT_VIEW_ROUTES.has(matchedRoute.route.name)
			: NAV3_TMP_PROJECT_VIEW_ROUTES.has(matchedRoute.route.name);
	}
	return false;
};
